function preferenceMiddlewareFactory(gridName, preferenceSetCallback) {
  return function preferenceMiddleware(action) {
    const { type, payload } = action;
    if (type === 'SET_EDITABLE_FILTER') {
      preferenceSetCallback({ Name: `${gridName}_Filter`, Data: payload });
    } else if (type === 'UPDATE_SORTED_COLUMN') {
      preferenceSetCallback({ Name: `${gridName}_Sorting`, Data: payload });
    } else if (type === 'UPDATE_SEGMENTATION') {
      preferenceSetCallback({ Name: `${gridName}_Segmentation`, Data: payload });
    } else if (type === 'UPDATE_PAGINATION') {
      preferenceSetCallback({ Name: `${gridName}_Pagination`, Data: payload });
    }
  };
}

function getGridPreferenceFactory(gridName, preferenceGetCallback) {
  return function getGridPreference() {
    const preferenceFilter = preferenceGetCallback({ Name: `${gridName}_Filter` });
    const preferenceSorting = preferenceGetCallback({ Name: `${gridName}_Sorting` });
    const preferenceSegmentation = preferenceGetCallback({ Name: `${gridName}_Segmentation` });
    const preferencePagination = preferenceGetCallback({ Name: `${gridName}_Pagination` });
    return {
      ...(preferenceFilter ? { filter: preferenceFilter } : {}),
      ...(preferenceSorting ? { sortedColumn: preferenceSorting } : {}),
      ...(preferenceSegmentation ? { segmentation: preferenceSegmentation } : {}),
      ...(preferencePagination ? { pagination: preferencePagination } : {}),
    };
  };
}

export function preferenceFactory(gridName, preferenceSetCallback, preferenceGetCallback) {
  return {
    getGridPreference: getGridPreferenceFactory(gridName, preferenceGetCallback),
    preferenceMiddleware: preferenceMiddlewareFactory(gridName, preferenceSetCallback),
  };
}
